import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PortalShell } from './components/layout/PortalShell';
import { Home } from './pages/Home';
import { SectionView } from './pages/SectionView';
import { SupplierNetwork } from './pages/SupplierNetwork';
import { PinGate } from './components/PinGate';
export function App() {
  return <PinGate data-id="element-0" data-mp="3f8ndzhg0d981">
      <Router data-id="element-1" data-mp="2rkx67l5bqppn">
        <PortalShell data-id="element-2" data-mp="2rkdxmv1kddoa">
          <Routes data-id="element-3" data-mp="2rlynw8guiagc">
            <Route path="/" element={<Home data-id="element-5" data-mp="2rikmp3jx47ah" />} data-id="element-4" data-mp="2rl6un4aq0ot8" />
            <Route path="/section/:id" element={<SectionView data-id="element-7" data-mp="2mn5a0exnchfn" />} data-id="element-6" data-mp="2mmce69087cca" />
            <Route path="/supplier-network" element={<SupplierNetwork data-id="element-9" data-mp="31b8fzobovt4g" />} data-id="element-8" data-mp="2mjpy1kz9roig" />
          </Routes>
        </PortalShell>
      </Router>
    </PinGate>;
}